import { GetCookieProps, SetCookieProps } from '../types';

function getCookie({ cookies, name }: GetCookieProps): any {
  return cookies.get(name);
}

function setCookie({ cookies, name, value, options }: SetCookieProps): void {
  return cookies.set(name, value, options);
}

function removeCookie({ cookies, name }: GetCookieProps): void {
  return cookies.remove(name);
}

export { getCookie, setCookie, removeCookie };
